import React from 'react';

import StyledLink from 'app/team-guide/components/StyledLink';

const BASE_VIDEO_URL = `/videos/team-guide/`;

export const HowDoIShareZaps = {
  question: 'How do I Share Zaps?',
  answer: null,
  mediaUrl: `${BASE_VIDEO_URL}/how-share-zaps.mp4`,
  key: 'HowDoIShareZaps',
};

export const CanShareEntireFolder = {
  question: 'Can I Share an Entire Folder?',
  answer: null,
  mediaUrl: `${BASE_VIDEO_URL}/can-share-folders.mp4`,
  key: 'CanShareEntireFolder',
};

export const CanInviteMembers = {
  question: 'How do I Invite Team Members?',
  answer: (
    <p>
      Go to your <StyledLink href="app/settings">Settings</StyledLink> and then
      follow these steps:
    </p>
  ),
  mediaUrl: `${BASE_VIDEO_URL}/can-invite-members.mp4`,
  key: 'CanInviteMembers',
};

export const CanTeamSeeMyZaps = {
  question: 'Can my Teammates See my Zaps?',
  answer: (
    <div>
      <p>
        It depends. In your <strong>shared folders</strong>, your team members
        can see and access your Zaps. If you want to hide them, you'll need to
        move them to your private folder.
      </p>
      <p>
        Zaps in <strong>private folders</strong> remain hidden from the rest of
        your team—only you can see them or edit them.
      </p>
    </div>
  ),
  mediaUrl: '',
  key: 'CanTeamSeeMyZaps',
};

export const ViewTypes = {
  welcome: 'welcome',
  guide: 'guide',
  HowDoIShareZaps: 'HowDoIShareZaps',
  CanShareEntireFolder: 'CanShareEntireFolder',
  CanInviteMembers: 'CanInviteMembers',
  CanTeamSeeMyZaps: 'CanTeamSeeMyZaps',
};

export const FAQObject = {
  HowDoIShareZaps,
  CanShareEntireFolder,
  CanInviteMembers,
  CanTeamSeeMyZaps,
};

export const FAQ = [
  HowDoIShareZaps,
  CanShareEntireFolder,
  CanInviteMembers,
  CanTeamSeeMyZaps,
];
